import APIExchange from 'components/APIKey/APIExchange'
import ApiTable from 'components/APIKey/ApiTable'
import React from 'react'


function ApiCredentials() {
  return (
    <>
    <div className='mx-auto'>
        
      <APIExchange />
      <ApiTable />
    </div>
    </>
  )
}

export default ApiCredentials